import styled from 'styled-components';
import { Button, Modal, tombac, useTombac } from 'tombac';
import { TickIcon } from 'tombac-icons';
import { ProductModalHeader } from "./ProductModalHeader";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActionBar = styled.div.withConfig({
  displayName: "AddAccessSuccessModal__ActionBar"
})(["display:flex;margin-left:auto;padding:", ";width:min-content;"], tombac.space(2, 4, 3));
export const AddAccessSuccessModal = _ref => {
  let {
    isOpen,
    onRequestClose,
    onRequestLimitsEditOpen
  } = _ref;
  const tombac = useTombac();
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "AddAccessSuccessModal",
    "data-sentry-source-file": "AddAccessSuccessModal.tsx",
    children: [/*#__PURE__*/_jsx(ProductModalHeader, {
      icon: /*#__PURE__*/_jsx(TickIcon, {
        color: tombac.color('success', 800),
        size: 5
      }),
      onRequestClose: onRequestClose,
      subtitle: "Do you want to set the limits for this new access now?",
      title: "New access was added!",
      "data-sentry-element": "ProductModalHeader",
      "data-sentry-source-file": "AddAccessSuccessModal.tsx",
      "data-sentry-element": "ProductModalHeader"
    }), /*#__PURE__*/_jsxs(ActionBar, {
      "data-sentry-element": "ActionBar",
      "data-sentry-source-file": "AddAccessSuccessModal.tsx",
      "data-sentry-element": "ActionBar",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onRequestClose,
        variant: "flat",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "AddAccessSuccessModal.tsx",
        "data-sentry-element": "Button",
        children: "No, I will set them later"
      }), /*#__PURE__*/_jsx(Button, {
        $ml: "1sp",
        onClick: onRequestLimitsEditOpen,
        variant: "primary",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "AddAccessSuccessModal.tsx",
        "data-sentry-element": "Button",
        children: "Yes, set limits now"
      })]
    })]
  });
};